<template>
    <div class="confirm">
        <div v-for="(item,index) in records" :key="index" class="item">
            <div class="title">{{item.TYPE}}</div>
            <div class="info">
                <ul>
                    <li>
                        <b>•基本信息</b>
                        <div><span class="textright">体检人：</span><span>{{item.NAME}}</span></div>
                        <div>
                            <span class="textright">联系电话：</span><span>{{item.PHONE_NUM}}</span>
                        </div>
                    </li>
                    <li>
                        <b>•费用详情</b>
                        <h1>基础项目</h1>
                        <div class="tables">
                            <table>
                                <thead>
                                    <tr>
                                        <td>序号</td>
                                        <td>项目</td>
                                        <!-- <td>价格</td> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(li1,index1) in item.basicItems" :key="li1.index1" v-tip.click="getTip1(li1,index1)" :class="{rowactive:selIndex0==index1}">
                                        <td>{{index1+1}}</td>
                                        <td style="max-width:8em;">{{li1.CHECKITEM_NAME}}</td>
                                        <!-- <td>{{li1.ITEM_COST}}</td> -->
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <h1>新增项目</h1>
                        <div class="tables">
                            <table>
                                <thead>
                                    <tr>
                                        <td>序号</td>
                                        <td>项目</td>
                                        <td>价格</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(li2,index1) in item.addItems" :key="li2.index1" v-tip.click="getTip2(li2,index1)" :class="{rowactive:selIndex1==index1}">
                                        <td>{{index1+1}}</td>
                                        <td style="max-width:8em;">{{li2.CHECKITEM_NAME}}</td>
                                        <td>{{li2.ITEM_COST}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="subtotal" v-show="records.length>1"><span>小计：</span><b>¥{{item.PRICE}}</b></div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="buy">
            <div class="price">
                <span class="c3">合计：</span><b>¥{{totalPrice}}</b>
            </div>
            <button class="btnbuy" @click="submit">提交订单</button>
        </div>
        <van-popup v-model="show" position="bottom">
            <div class="pay">
                <div class="head"><i class="iconfont icon-error" @click="cancle"></i><span>确认付款</span></div>
                <h1>¥{{totalPrice}}</h1>
                <ul>
                    <li>
                        <h3>请选择支付方式</h3>
                        <!-- <div @click="selwx" class="items"> -->
                        <div class="items">
                            <img src="../assets/images/wx.png" alt="">
                            <div>
                                <!-- <h1>微信支付</h1> -->
                                <h2>微信支付</h2>
                                <!-- <h2>微信7.0及以上版本</h2> -->
                            </div>
                            <i :class="{'iconfont':true,'icon-webicon318':true,'active':this.wx}"></i>
                        </div>
                        <!-- <div @click="selzfb" class="items">
                                                                                <img src="../assets/images/zfb.png" alt="">
                                                                                <div>
                                                                                    <h1>支付宝</h1>
                                                                                    <h2>支付宝11.0及以上版本</h2>
                                                                                </div>
                                                                                <i :class="{'iconfont':true,'icon-webicon318':true,'active':this.zfb}"></i>
                                                                            </div> -->
                    </li>
                </ul>
                <div class="btnPay">
                    <van-button @click='pay' size="small">立即付款</van-button>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import {
        mapGetters
    } from 'vuex';
    import {
        Toast
    } from 'vant';
    import api from "@/fetch/api";
    const tips = {
        //template: `<div class="iteminfo"><div class="top"><i class="iconfont icon-error" @click="handler2"></i></div><van-cell-group class="tip"><van-cell title="项目名称：" v-model="ITEM_NAME" /><van-cell title="价格：" v-model="PRICE" /></van-cell-group></div>`,
    //   <div class="info-ok"><button type="button" @click="handler2">知道了</button></div>
    template: `<div class="iteminfo"><div class="top"><i class="iconfont icon-error" @click="handler2"></i></div><van-cell-group class="tip"><van-cell title="项目名称：" v-model="ITEM_NAME" /></van-cell-group></div>`,
      props: {
            ITEM_NAME: String,
            PRICE: Number,
            handler: Function,
            SEL_INDEX: Number
        },
        created() {
            this.$emit('sel', this.SEL_INDEX)
        },
        methods: {
            handler2() {
                this.$emit('close')
            }
        },
       
    };
    export default {
        data() {
            return {
                orderIDs: [],
                // addItems: [],
                // basicItems: [],
                totalPrice: 0,
                show: false,
                wx: true,
                zfb: false,
                records: [],
                trade_state: '',
                selIndex0: -1,
                selIndex1: -1,
            }
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.getOrderInfo(vm)
            })
        },
        computed: {
            ...mapGetters(["loginStatus", "userInfo"]),
        },
        methods: {
            getOrderInfo(el) {
                this.orderIDs = el.$route.params.orderID.split(',');
                var data = JSON.parse(sessionStorage.getItem('records'));
                console.log(data);
                if (Array.isArray(data)) {
                    data.forEach(n => {
                        n.basicItems = [];
                        n.addItems = [];
                    });
                    this.records = data;
                } else {
                    if (data.RECORD_ID.length > 0) {
                        //为空则取sessionstorage里的数据
                        data.basicItems = [];
                        data.addItems = [];
                    }
                    this.records.push(data);
                }
                console.log(this.records);
                this.records.forEach(el => {
                    console.log(el);
                    if (el.RECORD_ID.length > 0) {
                        //不为空则取接口里的数据
                        api.queryMyOrderItems(el.RECORD_ID).then(re => {
                            let data = re.data;
                            console.log(data);
                            el.addItems = data.addItems;
                            el.basicItems = data.basicItems;
                        });
                    }
                    this.totalPrice += parseFloat(el.PRICE);
                });
            },
            submit() {
                this.$dialog.confirm({
                    title: '提示',
                    message: '请仔细核对订单，确认付款后不能撤销、不予退款，敬请谅解',
                    cancelButtonText: '不同意',
                    confirmButtonText:'同意'
                }).then(() => {
                    // on confirm
                  this.show = true;
                  
            
                }).catch(() => {
                    // on cancel
                });
                
            },
            selwx() {
                this.wx = !this.wx;
                this.zfb = false;
            },
            selzfb() {
                this.zfb = !this.zfb;
                this.wx = false;
            },
            newUuid() {
                if (this.trade_state == '') {
                    let len = len || 32;
                    var chars = '0123456789abcdefghijklmnopqrstuvwxyz';
                    let maxPos = chars.length;
                    let uuid = '';
                    for (var i = 0; i < len; i++) {
                        uuid += chars.charAt(Math.floor(Math.random() * maxPos));
                    };
                    this.trade_state = uuid;
                }
            },
            pay() {
                this.show = false;
                Toast.loading({
                    mask: true,
                    message: '支付中...'
                });
                let that = this;
                this.newUuid();
                var data = JSON.parse(sessionStorage.getItem('records'));
                if (Array.isArray(data) || data.RECORD_ID.length > 0) {
                    var url = location.href; 
                    var address = ""
                    console.log(url);
                    if (url.indexOf("?") != -1) { 
                        var str = url.substr(7); 
                        var strs = url.split("&state="); 
                        console.log(strs[1]);
                        address = strs[0]
                    }
                    api.pay(that.totalPrice, that.trade_state, that.userInfo.CUSTOMER_ID,address).then(v => {
                        if (v.success == 'ok') {
                            //调用jsAPI
                            if (typeof WeixinJSBridge == undefined) {
                                if (document.addEventListener) {
                                    document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                                } else if (document.attachEvent) {
                                    document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                                    document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
                                }
                            } else {
                                WeixinJSBridge.invoke(
                                    'getBrandWCPayRequest', {
                                        "appId": v.appid, //公众号名称，由商户传入     
                                        "timeStamp": v.timeStamp, //时间戳，自1970年以来的秒数     
                                        "nonceStr": v.nonceStr, //随机串     
                                        "package": v.package,
                                        "signType": "MD5", //微信签名方式：     
                                        "paySign": v.paySign //微信签名 
                                    },
                                    function(res) {
                                        api.payQuery(that.trade_state).then(re => {
                                            let ret = re.success;
                                            if (ret != undefined) {
                                                if (ret == 'SUCCESS') {
                                                    let params = {
                                                        orderIds: that.orderIDs,
                                                        STATUS: 10
                                                    };
                                                    api.changeOrderStatus(that.userInfo.CUSTOMER_ID, params).then(re => {
                                                        console.log(re);
                                                        if (re.result == true) {
                                                            console.log(re);
                                                            setTimeout(() => {
                                                                if (that.orderIDs.length == 1) {
                                                                    that.$router.replace({
                                                                        path: '/user/paySuccess',
                                                                        query: {
                                                                            orderID: that.orderIDs[0]
                                                                        }
                                                                    })
                                                                } else {
                                                                    that.$router.replace('/user/paySuccess')
                                                                }
                                                            }, 3000);
                                                        }
                                                    });
                                                } else {
                                                    switch (ret) {
                                                        case 'REFUND':
                                                            Toast('转入退款');
                                                            break;
                                                        case 'NOTPAY':
                                                            Toast('未支付');
                                                            break;
                                                        case 'CLOSED':
                                                            Toast('已关闭');
                                                            break;
                                                        case 'REVOKED':
                                                            Toast('已撤销（刷卡支付）');
                                                            break;
                                                        case 'USERPAYING':
                                                            Toast('用户支付中');
                                                            break;
                                                        case 'PAYERROR':
                                                            Toast.fail('支付失败');
                                                            break;
                                                    }
                                                }
                                            } else {
                                                Toast.fail('支付失败');
                                            }
                                        });
                                    });
                            }
                        } else {
                            Toast.fail('内部程序出错');
                        }
                    });
                } else {
                    let addItemIDs = [];
                    let basicItemIDs = [];
                    console.log(data);
                    data.addItems.forEach(v => addItemIDs.push(v.CHECKITEM_ID));
                    data.basicItems.forEach(v => basicItemIDs.push(v.CHECKITEM_ID));
                    let params = {
                        COMBO_ID: data.COMBO_ID,
                        addItemId: addItemIDs,
                        basicItemId: basicItemIDs,
                        STATUS: 10,
                        PRICE: this.totalPrice,
                        TYPE: data.COMBO_TYPE
                    };
                    console.log(data.customerID, this.userInfo.CUSTOMER_ID, params);
                    var url = location.href; 
                    var address = ""
                    if (url.indexOf("?") != -1) { 
                        var str = url.substr(7); 
                        var strs = url.split("&state="); 
                        console.log(strs[1]);
                        address = strs[0]
                    }
                    api.pay(that.totalPrice, that.trade_state, that.userInfo.CUSTOMER_ID,address).then(v => {
                        if (v.success == 'ok') {
                            //调用jsAPI
                            if (typeof WeixinJSBridge == undefined) {
                                if (document.addEventListener) {
                                    document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                                } else if (document.attachEvent) {
                                    document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                                    document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
                                }
                            } else {
                                WeixinJSBridge.invoke(
                                    'getBrandWCPayRequest', {
                                        "appId": v.appid, //公众号名称，由商户传入     
                                        "timeStamp": v.timeStamp, //时间戳，自1970年以来的秒数     
                                        "nonceStr": v.nonceStr, //随机串     
                                        "package": v.package,
                                        "signType": "MD5", //微信签名方式：     
                                        "paySign": v.paySign //微信签名 
                                    },
                                    function(res) {
                                        api.payQuery(that.trade_state).then(re => {
                                            let ret = re.success;
                                            if (ret != undefined) {
                                                if (ret == 'SUCCESS') {
                                                    api.weixinOrder(data.customerID, that.userInfo.CUSTOMER_ID, params).then(res => {
                                                        let orderID = res.data;
                                                        if (orderID != undefined && orderID.length > 0) {
                                                            Toast.success('支付成功');
                                                            setTimeout(() => {
                                                                that.$router.replace({
                                                                    path: '/user/paySuccess',
                                                                    query: {
                                                                        orderID: orderID
                                                                    }
                                                                })
                                                            }, 3000);
                                                        } else {
                                                            Toast.fail('内部程序出错');
                                                        }
                                                    })
                                                } else {
                                                    switch (ret) {
                                                        case 'REFUND':
                                                            Toast('转入退款');
                                                            break;
                                                        case 'NOTPAY':
                                                            Toast('未支付');
                                                            break;
                                                        case 'CLOSED':
                                                            Toast('已关闭');
                                                            break;
                                                        case 'REVOKED':
                                                            Toast('已撤销（刷卡支付）');
                                                            break;
                                                        case 'USERPAYING':
                                                            Toast('用户支付中');
                                                            break;
                                                        case 'PAYERROR':
                                                            Toast.fail('支付失败');
                                                            break;
                                                    }
                                                }
                                            } else {
                                                Toast.fail('支付失败');
                                            }
                                        });
                                    });
                            }
                        } else {
                            Toast.fail('内部程序出错');
                        }
                    });
                }
            },
            cancle() {
                var data = JSON.parse(sessionStorage.getItem('records'));
                if (!Array.isArray(data) && data.RECORD_ID.length == 0) {
                    //加入购物车
                    let addItemIDs = [];
                    data.addItems.forEach(v => addItemIDs.push(v.CHECKITEM_ID));
                    let params = {
                        COMBO_ID: data.COMBO_ID,
                        addItemId: addItemIDs,
                        STATUS: 5,
                        PRICE: this.totalPrice,
                        TYPE: data.COMBO_TYPE
                    };
                    console.log(data.customerID);
                    console.log(this.userInfo.CUSTOMER_ID);
                    console.log(params);
                    api.weixinOrder(data.customerID, this.userInfo.CUSTOMER_ID, params)
                        .then(res => {
                            console.log(res);
                            if (res.result == true) {
                                // Toast.success('添加购物车成功');
                                this.$router.replace('/user/orderPay')
                            }
                        });
                } else {
                    let params = {
                        orderIds: this.orderIDs,
                        STATUS: 5
                    };
                    // this.show = false;
                    api.changeOrderStatus(this.userInfo.CUSTOMER_ID, params).then(re => {
                        console.log(re);
                        if (re.result == true) {
                            this.$router.replace('/user/orderPay')
                            // this.$router.back(-1);
                        }
                    });
                }
            },
            getTip(obj) {
                let that = this;
                return {
                    width: '80%',
                    transition: false,
                    container: document.getElementById('app'),
                    // 优先在 top bottom 方向上显示
                    placements: ['top', 'bottom'],
                    customProps: {
                        ITEM_NAME: obj.CHECKITEM_NAME,
                        PRICE: obj.ITEM_COST,
                        handler() {
                            that.tipsHidden();
                        }
                    },
                    duration: 30,
                    customListeners: {},
                    customComponent: tips
                }
            },
            tipsHidden() {
                var tipInstance = this.$tip(this.tips);
                tipInstance.hiddenTip(true);
            },
            getTip1(obj, index1) {
                let that = this;
                return {
                    width: '80%',
                    transition: false,
                    container: document.getElementById('app'),
                    // 优先在 top bottom 方向上显示
                    placements: ['top', 'bottom'],
                    customProps: {
                        ITEM_NAME: obj.CHECKITEM_NAME,
                        PRICE: obj.ITEM_COST,
                        SEL_INDEX: index1,
                        handler() {
                            that.tipsHidden();
                        }
                    },
                    duration: 30,
                    customListeners: {
                        sel(val) {
                            that.selIndex0 = val;
                            that.selIndex1 = -1;
                            console.log(that.selIndex0)
                        },
                        close() {
                            that.tipsHidden();
                        }
                    },
                    customComponent: tips
                };
            },
            getTip2(obj, index2) {
                let that = this;
                return {
                    width: '80%',
                    transition: false,
                    container: document.getElementById('app'),
                    // 优先在 top bottom 方向上显示
                    placements: ['top', 'bottom'],
                    customProps: {
                        ITEM_NAME: obj.CHECKITEM_NAME,
                        PRICE: obj.ITEM_COST,
                        SEL_INDEX: index2,
                        handler() {
                            that.tipsHidden();
                        }
                    },
                    duration: 30,
                    customListeners: {
                        sel(val) {
                            that.selIndex0 = -1;
                            that.selIndex1 = val;
                            console.log(that.selIndex1)
                        },
                        close() {
                            console.log(that)
                            that.tipsHidden();
                        }
                    },
                    customComponent: tips
                };
            }
        }
    }
</script>

<style scoped lang='less'>
    .confirm {
        background: #f0f0f0;
        margin-bottom: 4em;
        .item {
            background: #fff;
            margin-bottom: 1em;
        }
        .pay {
            .head {
                padding: 0.5em;
                position: relative;
                text-align: center;
                border-bottom: 1px solid rgb(226, 226, 226);
                .iconfont {
                    position: absolute;
                    left: 0.3em;
                    top: 0.4em;
                }
            }
            .btnPay {
                text-align: center;
            }
            button {
                background: #99C51D;
                margin: 1em auto;
                color: #fff;
                font-weight: bold;
                font-size: 1rem;
                width: 95%;
                border-radius: 10px;
                height: 3em;
            }
            h1 {
                text-align: center;
                font-weight: normal;
                padding: 1em 0 0.3em 0;
            }
            ul {
                li {
                    font-size: 0.8rem;
                    color: #333;
                }
            }
            .items {
                border-bottom: 1px solid rgb(226, 226, 226);
                position: relative;
                margin-bottom: 0.4em;
                img {
                    position: absolute;
                    left: 1em;
                    top: 0;
                    width: 2.5em;
                }
                >div {
                    margin-left: 5em;
                    h1 {
                        color: #333;
                    }
                    h2 {
                        color: #999;
                    }
                    h1,
                    h2 {
                        padding: 0.3em 0;
                        margin: 0;
                        text-align: left;
                        font-size: 1.2em;
                        background: #fff;
                        line-height: 1.5em;
                    }
                }
                i {
                    position: absolute;
                    right: 1em;
                    top: 0.4em;
                    color: #999;
                }
                .active {
                    color: #99C51D;
                }
            }
        }
        .buy {
            padding-left: 1rem;
            .btnbuy {
                padding: 0 1em;
            }
            .price {
                span {
                    display: inline;
                    font-size: 0.8rem !important;
                }
            }
        }
        .tables {
            border: 0;
            width: 100%;
            padding: 0;
            margin: 0;
            .rowactive {
                background: #FF7C3E;
                td {
                    color: #fff !important;
                }
            }
            td {
                height: 1.8em !important;
                border-bottom: 1px solid rgb(226, 226, 226);
                color: #999 !important;
            }
        }
        .title {
            height: 2em;
            font-size: 0.95rem;
            border-width: 4px;
            border-style: solid;
            border-color: #43852E;
            border-top: 0px;
            border-right: 0px;
            border-bottom: 0px;
            border-radius: 0px;
            line-height: 2em;
            padding-left: 1em;
            font-weight: bold;
            border-bottom: 1px solid rgb(226, 226, 226);
            color: #666;
        } // .info {
        //     margin-bottom: 4rem;
        // }
        li {
            color: #99C51D;
            font-size: 0.8rem;
            padding: 0.5em 1em;
            b {
                line-height: 2em;
            }
            >h1 {
                background: rgba(246, 246, 246, 1);
                font-size: 0.8rem;
                line-height: 3em;
                height: 3em;
                color: #333;
                text-align: center;
                font-weight: normal;
            }
            >div {
                color: #666;
                line-height: 2em;
                span {
                    display: inline-block;
                    min-width: 6em;
                    margin-right: 1em;
                }
                padding-bottom: 0.5em;
            }
            .subtotal {
                margin-top: 0.5em;
                text-align: right;
                border-top: 1px solid #43852E;
                span {
                    min-width: 2em;
                }
                b {
                    color: #43852E;
                }
            }
        }
    }
   
</style>


// WEBPACK FOOTER //
// src/pages/confimOrder.vue